import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWorkspace } from '@/hooks/useWorkspace';
import { LoadingPage } from './LoadingPage';

interface LegacyRouteRedirectProps {
  to: 'dashboard' | 'chat' | 'personas' | 'analysis';
}

export const LegacyRouteRedirect = ({ to }: LegacyRouteRedirectProps) => {
  const navigate = useNavigate();
  const { currentCompany, isLoadingCompanies } = useWorkspace();

  useEffect(() => {
    if (isLoadingCompanies) return;

    // If user has a current company, redirect to workspace route
    if (currentCompany) {
      navigate(`/w/${currentCompany.slug}/${to}`, { replace: true });
    } else {
      // No current company selected (regardless of how many companies exist)
      // Always redirect to companies page to force selection
      navigate('/companies', { replace: true });
    }
  }, [currentCompany, isLoadingCompanies, navigate, to]);

  return <LoadingPage />;
};